export default {
  banner: {
    title: "私たちについて",
    subtitle: "ID 管理を容易にし、企業のデータ資産を保護する",
    "label-one": "ユーザ認証",
    "label-two": "国家を分布させる",
    "label-three": "顧客サービス",
    "label-four": "サービス時間",
  },
  company: {
    title: "会社の紹介",
    "descript-one":
      "Authing は、中国をリードする Cloud ID インフラストラクチャであり、企業や開発者向けに高速で安全なアイデンティティとアクセス管理ソリューションを提供している。 クロスプラットフォームのサーバーレス認証クラウドプラットフォームにより、企業は数千万人規模の外部ユーザー管理、数万人規模の従業員管理、数千人規模の SaaS 管理、数十億規模の IoT デバイス管理を安全かつ信頼性の高い方法で実現することができる。 2020年から毎月何百万人もの人が Authing プラットフォームに認定され、急成長を遂げています。 その開発者のユーザーは世界30カ国以上にいて、教育、政府機関、金融、製造業などの分野をカバーしている。 チームは IBM, Alibaba Cloud, ByteDance, Didi Dache, iQiyi, Motorola など業界をリードする企業から集まっている。",
    "descript-two":
      "Authing の主な機能は以下の通り：シングルサインオン、ユーザー分析、スワイプログオン、多要素認証、行動監査、リスク管理、クロスプラットフォームデバイス管理、IoT認証など；様々な国際標準プロトコルに対応：OAuth2.0、OIDC、SAML、AD/LDAP、WS-Fed、JWT など；また、関数計算に基づく Authing 機能を無制限に拡張する Pipeline がある。企業や開発者の生産性を1,000倍に向上させるためのクラウドデリバリとプライベートデプロイメントをサポートする。",
  },
  process: {
    title: "開発の歴史",
  },
  copyright: {
    title: "ソフトウェア著作権",
  },
  form: {
    title: "価格表の詳しい情報？",
    subtitle: "お客様の連絡先情報をご記入ください。",
    name: "姓名",
    "name-placeholder": "希望我们怎么称呼你？",
    "phone-placeholder": "我们的顾问将尽快致电你",
    other: "备注信息",
    submit: "立即提交",
  },
  0: "ID 管理を容易にし、企業のデータ資産を保護する",
  1: "Authing は、中国をリードする Cloud ID インフラストラクチャであり、企業や開発者向けに高速で安全なアイデンティティとアクセス管理ソリューションを提供している。 クロスプラットフォームのサーバーレス認証クラウドプラットフォームにより、企業は数千万人規模の外部ユーザー管理、数万人規模の従業員管理、数千人規模の SaaS 管理、数十億規模の IoT デバイス管理を安全かつ信頼性の高い方法で実現することができる。 2020年から毎月何百万人もの人が Authing プラットフォームに認定され、急成長を遂げています。 その開発者のユーザーは世界30カ国以上にいて、教育、政府機関、金融、製造業などの分野をカバーしている。 チームは IBM, Alibaba Cloud, ByteDance, Didi Dache, iQiyi, Motorola など業界をリードする企業から集まっている。",
  2: "Authing の主な機能は以下の通り：<strong>シングルサインオン、ユーザー分析、スワイプログオン、多要素認証、行動監査、リスク管理、クロスプラットフォームデバイス管理、IoT認証など</strong>；様々な国際標準プロトコルに対応：<strong  >OAuth2.0、OIDC、SAML、AD/LDAP、WS-Fed、JWT など</strong>；また、関数計算に基づく Authing 機能を無制限に拡張する <strong>Pipeline</strong> がある。企業や開発者の生産性を1,000倍に向上させるための<strong>クラウドデリバリとプライベートデプロイメント</strong> をサポートする。",
  3: "Authing Identity Cloud は「2019年サイバーセキュリティ業界レポート」セキュリティ製品パノラマに収録されていた。",
  4: "Aauthing は、シリコンバレーで有名なインキュベーターである PNP (PLUG AND PLAY) からシード投資を受けました。",
  5: "Authing Identity Cloud は「中国のサイバーセキュリティ産業白書（2018年版）レポート」に収録されていた。",
  6: "YC 中国秋季キャンプトップ30",
  7: "Q1 Authing の MAU が600万個を突破した",
  8: "Q1 大手 toB エンタープライズサービスファンドからの数百万ドルのエンジェルラウンドの資金調達を完了した",
  9: "ID 管理を容易にし、企業のデータ資産を保護する",
  10: "Authing: 中国版 Auth0 Okta 似たようなサービスは？",
  关于我们: "私たちについて",
  用户认证: "ユーザ認証",
  分布国家: "国家を分布させる",
  客户服务: "顧客サービス",
  服务时间: "サービス時間",
  公司介绍: "会社の紹介",
  发展历程: "開発の歴史",
  软件著作权: "ソフトウェア著作権",
  相关链接: "関連リンク",
  官网: "ホームページ：",
  仓库: "デポ：",
  开发文档: "開発文書：",
  Gitter开发者社区: "Gitter 開発者コミュニティ：",
};
